import React from "react";
import modalStyles from "../../../../css/modal.module.css";
import StockTransferNonDrugView from "./StockTransferNonDrugView.jsx";
import StockTransferDrugView from "./StockTransferDrugView.jsx";

export default function StockTransferModal({ activeSegment, selectedRow, isApproved, onClose, onAddToInventory }) {
  if (!selectedRow) return null;

  const renderContent = () => {
    const isDrug =
      (selectedRow.type || "").toString().toLowerCase() === "drug" ||
      (selectedRow.productType || "").toString().toLowerCase().includes("scheduled drug");

    if (isDrug) {
      // Any SKU that exists in the drug table uses the drug view (with active ingredient)
      return (
        <StockTransferDrugView
          selectedRow={selectedRow}
          isApproved={isApproved}
          onAddToInventory={onAddToInventory}
        />
      );
    }

    // Non-drug / item SKUs use the non-drug view; tab controls the variant label
    const nonDrugVariant = activeSegment === "Clinic" ? "clinic" : "front-shop";

    return (
      <StockTransferNonDrugView
        variant={nonDrugVariant}
        selectedRow={selectedRow}
        isApproved={isApproved}
        onAddToInventory={onAddToInventory}
      />
    );
  };

  return (
    <div
      id="modal-popup"
      className={modalStyles.modalPopup}
      onClick={onClose}
    >
      <div
        className={`${modalStyles.modalContent} ${modalStyles.modalNoScrollbar}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className={modalStyles.closeBtn} onClick={onClose} aria-label="Close">
          ×
        </button>
        {renderContent()}
      </div>
    </div>
  );
}
